import React from 'react';

const WifiMetricMiniCard = ({ label, value, iconColor = 'text-success', icon='fas fa-chart-bar' }) => {
  return (
    <div className="d-flex flex-column align-items-start px-3">
      <div className="d-flex align-items-center mb-1">
        <span className="text-muted small mr-1">{label}</span>
        <i className={`${icon} ${iconColor}`} style={{ fontSize: '14px' }}></i>
      </div>
      <h4 className="mb-0" style={{ fontWeight: '50' }}>{value}</h4>
    </div>
  );
};

export default WifiMetricMiniCard;
